import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { PortfolioPlWidgetState } from './PortfolioPlWidgetState';
import {
    buildPortfolioPlConfigSlice,
    PortfolioPlConfigPayloadType,
} from 'widgets/portfolioPl/store/config/configSlice';
import {
    buildPortfolioPlStreamSlice,
    PortfolioPlStreamPayloadType,
} from 'widgets/portfolioPl/store/stream/streamSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const { reducer: streamReducer } = buildPortfolioPlStreamSlice();
const { reducer: configReducer } = buildPortfolioPlConfigSlice();

const widgetStateReducer = combineReducers<PortfolioPlWidgetState>({
    stream: streamReducer,
    config: configReducer,
});

export const portfolioPlWidgetsReducer = createWidgetsReducer<
    PortfolioPlWidgetState,
    PortfolioPlConfigPayloadType | PortfolioPlStreamPayloadType
>(WidgetType.PORTFOLIO_PL, widgetStateReducer);
